import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { useStoreActions, useStoreState } from "easy-peasy";
import SVG from "react-inlinesvg";
import { getSeconds } from "../../utils/timeUtils";
import analytics from "../../utils/analytics";

const NavigationBtn = ({
  label,
  iconUrl,
  iconAltText,
  timeMarker,
  isActive,
  index,
}) => {
  const extension = iconUrl && iconUrl.split(".").pop();
  const setPlaying = useStoreActions((actions) => actions.stage.setPlaying);
  const setBgmPlaying = useStoreActions((actions) => actions.bgm.setPlaying);
  const setActiveFeature = useStoreActions(
    (actions) => actions.features.setActiveFeature
  );
  const setExperiencePlaying = useStoreActions(
    (actions) => actions.experience.setPlaying
  );
  const setCurrentIntervalEnd = useStoreActions(
    (actions) => actions.analytics.setCurrentIntervalEnd
  );
  const { player: videoPlayer, isPlaying } = useStoreState(
    (state) => state.stage
  );
  const { isPlaying: isBgmPlaying } = useStoreState((state) => state.bgm);
  const { isPlaying: isExperiencePlaying } = useStoreState(
    (state) => state.experience
  );

  const handleNavClick = useCallback(() => {
    if (videoPlayer) {
      setCurrentIntervalEnd(videoPlayer.currentTime());
      videoPlayer.currentTime(getSeconds(timeMarker));
      setActiveFeature(index);
      if (!isPlaying) {
        setPlaying(true);
      }
      if (!isBgmPlaying) {
        setBgmPlaying(true);
      }
      if (!isExperiencePlaying) {
        setExperiencePlaying(true);
      }
    }
    if (label && index >= 0) {
      analytics.trackNavBtnClick(index + 1, label);
    }
  }, [
    videoPlayer,
    setPlaying,
    isPlaying,
    index,
    label,
    setActiveFeature,
    timeMarker,
    isExperiencePlaying,
    setExperiencePlaying,
    isBgmPlaying,
    setBgmPlaying,
    setCurrentIntervalEnd,
  ]);

  return (
    <li className={`demo-navigation__list-item ${isActive ? "is-active" : ""}`}>
      <button
        type="button"
        className={`demo-navigation__btn animate__animated ${
          isActive ? "is-active animate__buttonBounce" : ""
        }`}
        onClick={handleNavClick}
      >
        <span className="demo-navigation__btn-icon">
          {iconUrl && extension === "svg" ? (
            <SVG src={iconUrl} description={iconAltText} cacheRequests>
              <img src={iconUrl} alt={iconAltText} />
            </SVG>
          ) : (
            <img src={iconUrl} alt={iconAltText} />
          )}
        </span>
      </button>
    </li>
  );
};

NavigationBtn.propTypes = {
  label: PropTypes.string,
  index: PropTypes.number,
  iconUrl: PropTypes.string,
  iconAltText: PropTypes.string,
  timeMarker: PropTypes.string,
  isActive: PropTypes.bool,
};
NavigationBtn.defaultProps = {
  label: "",
  index: -1,
  iconUrl: "",
  iconAltText: "",
  timeMarker: "",
  isActive: false,
};

export default NavigationBtn;
